import React from 'react';
import { CircularProgress } from '../CircularProgress';
import { twMerge } from 'tailwind-merge';

interface LoadingStateProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'neutral' | 'soft';
  title?: string;
  description?: string;
  className?: string;
}

const LoadingState = ({
  size = 'md',
  color = 'primary',
  title = 'Loading Results',
  description = 'Please wait while we fetch your data...',
  className,
}: LoadingStateProps) => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center py-12 px-6 bg-neutral-50 border border-neutral-100 rounded-lg m-4',
        className
      )}
    >
      <div className="flex flex-col items-center gap-6">
        <CircularProgress size={size} color={color} />
        <div className="flex flex-col gap-1 text-center">
          <h4 className="text-base font-semibold text-neutral-600">{title}</h4>
          <p className="text-sm text-neutral-500 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
